import { Button, Grid, Typography } from "@mui/material";
import Calendar from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import gregorian_en from "react-date-object/locales/gregorian_en";
import Input from "./Input";
import { useEffect, useState } from "react";

const DatePicker = ({
  value,
  onChange,
  placeholder,
  label,
  disabled,
  id,
  name,
  labelFlex = 5,
  flex = 7,
  error = false,
  hasClearButton = true,
}) => {
  const [submitError, setSubmitError] = useState(
    (!value || value === undefined || value === "") && error
  );

  useEffect(() => {
    setSubmitError((!value || value === undefined || value === "") && error);
  }, [error, value]);

  return (
    <Grid container flexDirection="row-reverse" alignItems="center" flexWrap="wrap">
      <Grid
        item
        sx={{
          flex: labelFlex,
        }}
      >
        <Typography variant="h2" textAlign="right">
          {label}
        </Typography>
      </Grid>
      <Grid
        item
        sx={{
          flex: flex,
        }}
      >
        <Calendar
          calendar={persian}
          locale={persian_fa}
          mapDays={() => {
            return {
              style: {
                alignItems: "center",
              },
            };
          }}
          containerStyle={{ width: "100%" }}
          value={value}
          disabled={disabled}
          onChange={(date) => onChange(date.convert(persian, gregorian_en))}
          render={(value, openCalendar) => (
            <Input
              onClick={openCalendar}
              value={value}
              flex={1}
              placeholder={placeholder}
              disabled={disabled}
              id={id}
              name={name}
              error={submitError}
            />
          )}
        >
          {hasClearButton && (
            <Button onClick={() => onChange("")} sx={{ justifySelf: "flex-start" }}>
              پاک کردن
            </Button>
          )}
        </Calendar>
      </Grid>
    </Grid>
  );
};
export default DatePicker;
